import script from "./UploadFile.vue?vue&type=script&lang=ts&setup=true"
export * from "./UploadFile.vue?vue&type=script&lang=ts&setup=true"

import "./UploadFile.vue?vue&type=style&index=0&id=b2c1f280&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b2c1f280"]])

export default __exports__